export enum EExerciseStartType {
  FULL_COUNTDOWN,
  RANDOM
}
